import { frontendURL } from '../../../helper/URLHelper';
import AgentChatLayout from './pages/AgentChatLayout.vue';
import AgentChatIndex from './pages/AgentChatIndex.vue';
import AgentChatThread from './pages/AgentChatThread.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/agent-chat'),
    component: AgentChatLayout,
    children: [
      {
        path: '',
        name: 'agent_chat_index',
        component: AgentChatIndex,
        meta: {
          permissions: ['administrator', 'agent', 'custom_role'],
        },
      },
      {
        path: ':conversationId',
        name: 'agent_chat_thread',
        component: AgentChatThread,
        meta: {
          permissions: ['administrator', 'agent', 'custom_role'],
        },
      },
    ],
  },
];
